/**
 * Truncate a number to the specified number of decimals.
 * @param value
 * @param decimals
 */
export function truncateToDecimals(value: number, decimals = 2) {
	const factor = Math.pow(10, decimals)
	return Math.trunc(value * factor) / factor
}
